import Swiper, { Pagination, Navigation } from 'swiper';

class RecentEvents {
    constructor() {
        this.recentEvents = document.querySelector('.private-client__recent-events');
        this.init();
    }

    init() {
        if (this.recentEvents) {
            const swiper = new Swiper('.swiper', {
                speed: 500,
                spaceBetween: 20,
                slidesPerView: 4,
                slidesPerGroup: 1,
                slidesOffsetBefore: 20,
                centerInsufficientSlides: true,
                modules: [
                    Navigation,
                    Pagination
                ],
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                    dynamicBullets: true
                },
                navigation: {
                    nextEl: '.swiper-navigation-next',
                    prevEl: '.swiper-navigation-prev'
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1.2
                    },
                    600: {
                        slidesPerView: 2.3
                    },
                    960: {
                        slidesPerView: 3.3
                    },
                    1440: {
                        slidesPerView: 4.3
                    }
                }
            });
            this.fadeOutOfView(swiper);
            swiper.on('slideChange', swiper => {
                this.fadeOutOfView(swiper);
            });
            swiper.on('resize', swiper => {
                this.fadeOutOfView(swiper);
            })
        }
    }

    fadeOutOfView(swiper) {
        swiper.slides.forEach((slide, i) => {
            if(i + 1 > swiper.params.slidesPerView + swiper.activeIndex) {
                slide.classList.add('fade');
            } else {
                slide.classList.remove('fade');
            }
        });
    }


}

export default RecentEvents;
